import { configHome } from "@pub/config";
import { ReactElement } from "react";

import { elementsWithDataSource, elementsWithoutDataSource } from "./Elements";
import { HomeLayoutProps } from "./Elements/utils";
import styles from "./homelayout.module.css";

export default function HomeLayout({ data }: HomeLayoutProps): ReactElement {
  return (
    <div className={styles.homeContainer}>
      {configHome.layoutGrid.elements.map((element, k) => {
        const hasDataSource = "dataSource" in element;
        const hasCustomComponent = "Component" in element;

        if (hasDataSource) {
          const ElementComponent = hasCustomComponent
            ? element.Component
            : elementsWithDataSource[element.name];
          return (
            <ElementComponent
              key={k}
              data={data}
              dataSource={element.dataSource}
              alternateBg={element.alternateBg}
              trendingBlock={element.trendingBlock}
              scrollable={element.scrollable}
              variant={element.variant}
              alternateSectionColor={element.alternateSectionColor}
              adConfig={element.adConfig}
            />
          );
        }

        // For components WITHOUT dataSource
        const ElementComponent = hasCustomComponent
          ? element.Component
          : elementsWithoutDataSource[element.name];
        return <ElementComponent key={k} data={data} />;
      })}
    </div>
  );
}
